import { BaseStore } from "../stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import CollaboratorsAPI from "../api/collaborators_api";

import { api_get } from "api/utils";

export type CollaboratorsProps = {
    cls: string;
    key: string;
    uuid: string;
    collab: string;
    variant: string;
    identity: string;
    status: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: CollaboratorsProps) => void;
};

// Domain object Collaborators
export class Collaborators implements CollaboratorsProps {
    cls = "";
    key = "";
    uuid = "";
    collab = "";
    variant = "";
    identity = "";
    status = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: CollaboratorsProps) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: CollaboratorsProps) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class CollaboratorsStore extends BaseStore<CollaboratorsProps, Collaborators> {

    getCollaborators(collabKey : string) : Collaborators[]{
        return this.items.filter(c => c.collab === collabKey).sort((a, b) => {
            return a.date_created > b.date_created ? 1 : -1;
        });
    }

    /*
    async fetchList(cursor = "") {
        CollaboratorsAPI.list(cursor).then((resp) => {
            this.receiveUpdate(resp.items);
            if (resp.cursor) {
                this.fetchList(resp.cursor);
            }
        })
    }
    */
    async fetchIdentityCollaboratorsByManager(
        manager_identity: string,
        assistant_identity: string,
        variant="collab",
        cursor = "") {
            const url = "/collaborators/list/by-manager";
            const data = { identity: manager_identity,
                assistant_identity: assistant_identity,
                variant,
                cursor: cursor || ''};

            const res = await api_get(url, data);
            if (!res.ok) {
                return null;
            }

            const i = await res.json();
            this.receiveUpdate(i.items);
            return i;
        }

    async fetchListForCollab(identityKey: string, collabKey:string, cursor = "") {
        return CollaboratorsAPI.listForCollab(identityKey, collabKey, cursor).then((resp) => {
            this.receiveUpdate(resp.items);
            if (resp.cursor) {
                this.fetchListForCollab(identityKey, collabKey, resp.cursor);
            }
            return resp.items;
        })
    }


    async fetchCollaborator(key: string) {
        CollaboratorsAPI.load(key).then((data: CollaboratorsProps) => {
            this.receiveUpdate(data);
        });
    }

    modelConstructor() {
        return Collaborators;
    }

}
